var _defs, _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    fill: "white",
    "data-name": "Layer 1",
    viewBox: "0 0 33.9 33.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:white;}.cls-2{fill:none;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17,33.9A17,17,0,1,1,33.9,17,17,17,0,0,1,17,33.9ZM17,1a16,16,0,1,0,16,16A16,16,0,0,0,17,1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.84,14.79V14.5a.12.12,0,0,1,.12-.13h1.39V12.15H11.88a1.22,1.22,0,0,0-1.22,1.21v9a1.22,1.22,0,0,0,1.22,1.22h1.47V21.38H12a.12.12,0,0,1-.12-.12V21a.12.12,0,0,1,.12-.12h1.39v-.76H12a.12.12,0,0,1-.12-.12v-.29a.12.12,0,0,1,.12-.13h1.39V18.8H12a.12.12,0,0,1-.12-.13v-.29a.12.12,0,0,1,.12-.12h1.39V17.5H12a.12.12,0,0,1-.12-.12v-.29A.12.12,0,0,1,12,17h1.39v-.75H12a.12.12,0,0,1-.12-.13v-.29a.12.12,0,0,1,.12-.12h1.39v-.76H12A.12.12,0,0,1,11.84,14.79Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    fill: "white",
    d: "M20.1,12.15v2.22h1.13a.13.13,0,0,1,.13.13v.29a.12.12,0,0,1-.13.12H20.1v.76h1.13a.12.12,0,0,1,.13.12v.29a.13.13,0,0,1-.13.13H20.1V17h1.13a.13.13,0,0,1,.13.13v.29a.12.12,0,0,1-.13.12H20.1v.76h1.13a.12.12,0,0,1,.13.12v.29a.13.13,0,0,1-.13.13H20.1v.75h1.13a.13.13,0,0,1,.13.13V20a.13.13,0,0,1-.13.12H20.1v.76h1.13a.12.12,0,0,1,.13.12v.29a.12.12,0,0,1-.13.12H20.1v2.08s0,.05,0,.08h1.23a1.22,1.22,0,0,0,1.21-1.22V16"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.37,
    y: 13.49,
    width: 2.69,
    height: 0.67,
    rx: 0.16
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.37,
    y: 15.12,
    width: 2.69,
    height: 0.67,
    rx: 0.16
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.37,
    y: 16.74,
    width: 2.69,
    height: 0.67,
    fill: "white",
    rx: 0.16
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.37,
    y: 18.36,
    width: 2.69,
    height: 0.67,
    rx: 0.16
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.37,
    y: 19.99,
    fill: "white",
    width: 2.69,
    height: 0.67,
    rx: 0.16
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 15.37,
    y: 21.61,
    width: 2.69,
    height: 0.67,
    rx: 0.16
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.94,16.07a1.41,1.41,0,0,1-.41-.07v6.32a1.22,1.22,0,0,1-1.21,1.22H20.09s0-.05,0-.08V21.38h1.13a.12.12,0,0,0,.13-.12V21a.12.12,0,0,0-.13-.12H20.1v-.76h1.13a.13.13,0,0,0,.13-.12v-.29a.13.13,0,0,0-.13-.13H20.1V18.8h1.13a.13.13,0,0,0,.13-.13v-.29a.12.12,0,0,0-.13-.12H20.1V17.5h1.13a.12.12,0,0,0,.13-.12v-.29a.13.13,0,0,0-.13-.13H20.1v-.75h1.13a.13.13,0,0,0,.13-.13v-.29a.12.12,0,0,0-.13-.12H20.1v-.76h1.13a.12.12,0,0,0,.13-.12V14.5a.13.13,0,0,0-.13-.13H20.1V12.15h-1V23.46A1.09,1.09,0,0,1,18,24.55H15.43a1.08,1.08,0,0,1-1.08-1.09V12.22a1.08,1.08,0,0,1,1.08-1.08h2.35a1.27,1.27,0,0,1-.06-.39,1.25,1.25,0,0,1,.15-.61H15.43a2.06,2.06,0,0,0-1.83,1.11H11.88a2.11,2.11,0,0,0-2.12,2.11v9a2.12,2.12,0,0,0,2.12,2.12H13.6a2.06,2.06,0,0,0,1.83,1.11H18a2.08,2.08,0,0,0,1.83-1.11h1.47a2.12,2.12,0,0,0,2.11-2.12V16A1.34,1.34,0,0,1,22.94,16.07ZM11.88,23.54a1.22,1.22,0,0,1-1.22-1.22v-9a1.22,1.22,0,0,1,1.22-1.21h1.47v2.22H12a.12.12,0,0,0-.12.13v.29a.12.12,0,0,0,.12.12h1.39v.76H12a.12.12,0,0,0-.12.12v.29a.12.12,0,0,0,.12.13h1.39V17H12a.12.12,0,0,0-.12.13v.29a.12.12,0,0,0,.12.12h1.39v.76H12a.12.12,0,0,0-.12.12v.29a.12.12,0,0,0,.12.13h1.39v.75H12a.12.12,0,0,0-.12.13V20a.12.12,0,0,0,.12.12h1.39v.76H12a.12.12,0,0,0-.12.12v.29a.12.12,0,0,0,.12.12h1.39v2.16Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.11,10.22H23.47V7.59a.54.54,0,1,0-1.07,0v2.63H19.77a.54.54,0,0,0,0,1.07H22.4v2.63a.54.54,0,1,0,1.07,0V11.29h2.64a.54.54,0,0,0,0-1.07Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalOff);
export default __webpack_public_path__ + "static/media/modal_off.2b0348b8e7cf7809e13155afba5d41d0.svg";
export { ForwardRef as ReactComponent };